import { AdsType, AdParts } from '.'

export const getAdsPart = (ads: AdsType | null, part: AdParts) =>
  ads?.[part] || null

export const getAdsTop = (ads: AdsType | null) => ads?.top
